export enum UserRole {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_ADMIN_LIGHT = 'ROLE_ADMIN_LIGHT',
    ROLE_USER = 'ROLE_USER',
    ROLE_EDUCATION_EDITOR = 'ROLE_EDUCATION_EDITOR',
    ROLE_ORGANIZATION = 'ROLE_ORGANIZATION',
    ROLE_SAR = 'ROLE_SAR',
    ROLE_EXTERNAL = 'ROLE_EXTERNAL',
}
